// extracted by mini-css-extract-plugin
export var post = "index-module--post--9U3gD";
export var postTitle = "index-module--postTitle--29E3s";
export var postDescription = "index-module--postDescription--3hDyF";